import React from "react";

import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  IconButton
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

const CONTACT_EMAIL = "contact.swadveda@gmail.com";
const CONTACT_PHONE_DISPLAY = "+91 90******92";
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";
const WHATSAPP_URL = WHATSAPP_NUMBER
  ? `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}`
  : "https://wa.me/?text=Hi%20SwadVeda%2C%20I%20need%20help%20with%20an%20order.";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const links = [
    {
      label: "Home",
      path: "/"
    },
    {
      label: "Shop",
      path: "/shop"
    },
    {
      label: "About Us",
      path: "/about"
    },
    {
      label: "Contact",
      path: "/contact"
    }
  ];

  return (
    <Box
      sx={{
        mt: 6,
        background:
          "linear-gradient(180deg,#5c0000 0%, #3b0000 100%)",
        color: "#fff",
        overflow: "hidden"
      }}
    >
      {/* GOLD BORDER */}
      <Box
        sx={{
          height: 3,
          background:
            "linear-gradient(to right,#d4a017,#f5d27a,#d4a017)"
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          py: {
            xs: 4,
            md: 5
          }
        }}
      >
        <Grid container spacing={4}>
          {/* BRAND */}
          <Grid item xs={12} md={5}>
            <Stack spacing={2}>
              {/* SMALLER LOGO */}
              <Box
                component="img"
                src="https://res.cloudinary.com/dshd6sbca/image/upload/v1779016235/ChatGPT_Image_May_17_2026_04_36_43_PM_huj76e.png"
                alt="SwadVeda"
                sx={{
                  width: {
                    xs: 160,
                    md: 210
                  },
                  background: "#fff",
                  borderRadius: "12px",
                  p: 1,
                  boxShadow:
                    "0 6px 18px rgba(0,0,0,0.18)"
                }}
              />

              <Typography
                sx={{
                  color:
                    "rgba(255,255,255,0.78)",
                  lineHeight: 1.8,
                  fontSize: 14,
                  maxWidth: 420
                }}
              >
                Authentic Indian spices crafted
                with purity, freshness and rich
                traditional flavors for every
                kitchen.
              </Typography>

              {/* SOCIAL */}
              <Stack
                direction="row"
                spacing={1.2}
              >
                {[
                  <FacebookRoundedIcon />,
                  <InstagramIcon />,
                  <TwitterIcon />
                ].map((icon, index) => (
                  <IconButton
                    key={index}
                    sx={{
                      width: 40,
                      height: 40,
                      background:
                        "rgba(255,255,255,0.08)",
                      color: "#fff",
                      border:
                        "1px solid rgba(255,255,255,0.08)",

                      "&:hover": {
                        background: "#d4a017",
                        color: "#5c0000"
                      }
                    }}
                  >
                    {icon}
                  </IconButton>
                ))}
              </Stack>
            </Stack>
          </Grid>

          {/* QUICK LINKS */}
          <Grid item xs={6} md={3}>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1rem",
                mb: 2.2,
                color: "#f5d27a"
              }}
            >
              Quick Links
            </Typography>

            <Stack spacing={1.5}>
              {links.map((link) => (
                <Box
                  key={link.label}
                  onClick={() =>
                    handleNavigation(link.path)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    cursor: "pointer",
                    transition: "0.3s ease",

                    "&:hover": {
                      transform:
                        "translateX(4px)"
                    }
                  }}
                >
                  <ArrowForwardIosRoundedIcon
                    sx={{
                      fontSize: 12,
                      color: "#d4a017"
                    }}
                  />

                  <Typography
                    sx={{
                      color:
                        "rgba(255,255,255,0.85)",
                      fontSize: 14,

                      "&:hover": {
                        color: "#fff"
                      }
                    }}
                  >
                    {link.label}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Grid>

          {/* CONTACT */}
          <Grid item xs={6} md={4}>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1rem",
                mb: 2.2,
                color: "#f5d27a"
              }}
            >
              Contact
            </Typography>

            <Stack spacing={2}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.2
                }}
              >
                <LocationOnRoundedIcon
                  sx={{
                    color: "#d4a017",
                    fontSize: 20
                  }}
                />

                <Typography
                  sx={{
                    color:
                      "rgba(255,255,255,0.8)",
                    fontSize: 14,
                    lineHeight: 1.7
                  }}
                >
                  Noida, Uttar Pradesh,
                  India
                </Typography>
              </Box>

              <Box
                component="a"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.2,
                  textDecoration: "none"
                }}
              >
                <CallRoundedIcon
                  sx={{
                    color: "#d4a017",
                    fontSize: 20
                  }}
                />

                <Typography
                  sx={{
                    color:
                      "rgba(255,255,255,0.8)",
                    fontSize: 14
                  }}
                >
                  {CONTACT_PHONE_DISPLAY}
                </Typography>
              </Box>

              <Box
                component="a"
                href={`mailto:${CONTACT_EMAIL}`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.2,
                  textDecoration: "none"
                }}
              >
                <EmailRoundedIcon
                  sx={{
                    color: "#d4a017",
                    fontSize: 20
                  }}
                />

                <Typography
                  sx={{
                    color:
                      "rgba(255,255,255,0.8)",
                    fontSize: 14
                  }}
                >
                  {CONTACT_EMAIL}
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        {/* BOTTOM */}
        <Box
          sx={{
            mt: 4,
            pt: 2.5,
            borderTop:
              "1px solid rgba(255,255,255,0.08)",
            display: "flex",
            flexDirection: {
              xs: "column",
              md: "row"
            },
            alignItems: "center",
            justifyContent:
              "space-between",
            gap: 1.5
          }}
        >
          <Typography
            sx={{
              color:
                "rgba(255,255,255,0.6)",
              fontSize: 13,
              textAlign: {
                xs: "center",
                md: "left"
              }
            }}
          >
            © {new Date().getFullYear()}{" "}
            SwadVeda Masale. All rights
            reserved.
          </Typography>

          <Stack
            direction="row"
            spacing={2}
            flexWrap="wrap"
            justifyContent="center"
          >
            {[
              "Privacy Policy",
              "Terms",
              "Support"
            ].map((item) => (
              <Typography
                key={item}
                sx={{
                  color:
                    "rgba(255,255,255,0.6)",
                  fontSize: 13,
                  cursor: "pointer",

                  "&:hover": {
                    color: "#f5d27a"
                  }
                }}
              >
                {item}
              </Typography>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
